import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// =====================================================
// API CONFIG
// =====================================================
const API_BASE =
  process.env.REACT_APP_API_URL ||
  "https://eduadmin.sindoor7.com";

const LOGIN_ENDPOINT =
  `${API_BASE}front-website-parent-login`;

// =====================================================
// LOGIN COMPONENT
// =====================================================
export default function Login() {
  const navigate = useNavigate();

  // =====================================================
  // STATES
  // =====================================================
  const [email, setEmail] = useState("demologinparent@gmail.com");
  const [password, setPassword] = useState("123456");

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [showForgotModal, setShowForgotModal] = useState(false);

  const [fieldErrors, setFieldErrors] = useState({
    email: "",
    password: "",
  });

  // =====================================================
  // VALIDATION
  // =====================================================
  const validate = () => {
    let valid = true;

    const errors = {
      email: "",
      password: "",
    };

    const emailValue = email.trim();

    if (!emailValue) {
      errors.email = "Email is required.";
      valid = false;
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)
    ) {
      errors.email = "Please enter a valid email address.";
      valid = false;
    }

    if (!password) {
      errors.password = "Password is required.";
      valid = false;
    } else if (password.length < 6) {
      errors.password =
        "Password must be at least 6 characters.";
      valid = false;
    }

    setFieldErrors(errors);

    return valid;
  };

  // =====================================================
  // EMAIL CHANGE
  // =====================================================
  const handleEmailChange = (e) => {
    setEmail(e.target.value);

    if (fieldErrors.email) {
      setFieldErrors((prev) => ({
        ...prev,
        email: "",
      }));
    }

    setError("");
    setSuccessMsg("");
  };

  // =====================================================
  // PASSWORD CHANGE
  // =====================================================
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);

    if (fieldErrors.password) {
      setFieldErrors((prev) => ({
        ...prev,
        password: "",
      }));
    }

    setError("");
    setSuccessMsg("");
  };

  // =====================================================
  // LOGIN SUBMIT
  // =====================================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccessMsg("");

    if (!validate()) {
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(LOGIN_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
          password: password,
        }),
      });

      const data = await res.json().catch(() => ({}));

      console.log("Login Response:", data);

      if (!res.ok || data?.status !== 1) {
        throw new Error(
          data?.message ||
            "Invalid email or password."
        );
      }

      // Login token
      const storage = rememberMe
        ? localStorage
        : sessionStorage;

      if (data?.token) {
        storage.setItem("token", data.token);
      }

      // Parent information
      if (data?.data) {
        storage.setItem(
          "parent",
          JSON.stringify(data.data)
        );

        storage.setItem(
          "student",
          JSON.stringify(data.data)
        );

        if (data.data.id) {
          storage.setItem(
            "parent_id",
            String(data.data.id)
          );

          storage.setItem(
            "student_id",
            String(data.data.id)
          );
        }

        if (data.data.school_id) {
          storage.setItem(
            "school_id",
            String(data.data.school_id)
          );
        }

        if (data.data.api_token) {
          storage.setItem(
            "api_token_Parent",
            data.data.api_token
          );
        }
      }

      storage.setItem(
        "isLoggedIn",
        "true"
      );

      setSuccessMsg(
        data?.message ||
          "Login successful!"
      );

      setTimeout(() => {
        navigate("/Parentdash-board");
      }, 800);

    } catch (error) {
      console.error("Login Error:", error);

      setError(
        error?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // STYLES
  // =====================================================
  const styles = {
    section: {
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      position: "relative",
      overflow: "hidden",
      background:
        "radial-gradient(circle at top left, #312e81 0%, transparent 35%), radial-gradient(circle at bottom right, #4c1d95 0%, transparent 35%), linear-gradient(135deg, #020617, #0f172a, #1e1b4b)",
      fontFamily:
        "Inter, Plus Jakarta Sans, Arial, sans-serif",
      boxSizing: "border-box",
    },

    orb1: {
      position: "absolute",
      width: "280px",
      height: "280px",
      borderRadius: "50%",
      background:
        "rgba(99, 102, 241, 0.20)",
      filter: "blur(60px)",
      top: "-100px",
      left: "-80px",
      pointerEvents: "none",
    },

    orb2: {
      position: "absolute",
      width: "300px",
      height: "300px",
      borderRadius: "50%",
      background:
        "rgba(168, 85, 247, 0.18)",
      filter: "blur(70px)",
      bottom: "-120px",
      right: "-100px",
      pointerEvents: "none",
    },

    wrapper: {
      width: "100%",
      maxWidth: "1120px",
      minHeight: "650px",
      display: "grid",
      gridTemplateColumns:
        "1.05fr 0.95fr",
      borderRadius: "30px",
      overflow: "hidden",
      position: "relative",
      zIndex: 2,
      border:
        "1px solid rgba(255,255,255,0.12)",
      background:
        "rgba(255,255,255,0.07)",
      backdropFilter: "blur(25px)",
      WebkitBackdropFilter: "blur(25px)",
      boxShadow:
        "0 30px 100px rgba(0,0,0,0.45)",
    },

    left: {
      padding: "55px 48px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      color: "#fff",
      background:
        "linear-gradient(145deg, rgba(79,70,229,0.55), rgba(30,27,75,0.35))",
      borderRight:
        "1px solid rgba(255,255,255,0.08)",
    },

    brand: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "15px",
      fontWeight: "800",
      letterSpacing: "0.5px",
      marginBottom: "22px",
    },

    brandIcon: {
      width: "46px",
      height: "46px",
      borderRadius: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "23px",
      background:
        "rgba(255,255,255,0.14)",
      border:
        "1px solid rgba(255,255,255,0.15)",
    },

    badge: {
      display: "inline-flex",
      alignItems: "center",
      width: "fit-content",
      padding: "8px 13px",
      borderRadius: "50px",
      fontSize: "11px",
      fontWeight: "700",
      letterSpacing: "1px",
      color: "#c7d2fe",
      background:
        "rgba(99,102,241,0.18)",
      border:
        "1px solid rgba(165,180,252,0.2)",
      marginBottom: "20px",
    },

    title: {
      margin: 0,
      fontSize: "48px",
      lineHeight: "1.08",
      fontWeight: "800",
      letterSpacing: "-1.5px",
    },

    description: {
      color: "rgba(255,255,255,0.72)",
      fontSize: "15px",
      lineHeight: "1.8",
      marginTop: "20px",
      maxWidth: "500px",
    },

    features: {
      display: "grid",
      gridTemplateColumns:
        "1fr 1fr",
      gap: "12px",
      marginTop: "30px",
    },

    feature: {
      padding: "14px",
      borderRadius: "15px",
      background:
        "rgba(255,255,255,0.07)",
      border:
        "1px solid rgba(255,255,255,0.08)",
      color: "#e2e8f0",
      fontSize: "12px",
      lineHeight: "1.5",
    },

    featureIcon: {
      fontSize: "18px",
      marginBottom: "5px",
    },

    stats: {
      display: "flex",
      gap: "35px",
      marginTop: "35px",
    },

    statNumber: {
      fontSize: "24px",
      fontWeight: "800",
      color: "#fff",
    },

    statLabel: {
      fontSize: "11px",
      color:
        "rgba(255,255,255,0.6)",
      marginTop: "3px",
    },

    right: {
      padding: "55px 48px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      background:
        "rgba(255,255,255,0.97)",
    },

    welcome: {
      color: "#6366f1",
      fontSize: "13px",
      fontWeight: "700",
      marginBottom: "8px",
      letterSpacing: "0.5px",
    },

    signTitle: {
      margin: 0,
      fontSize: "34px",
      fontWeight: "800",
      color: "#0f172a",
      letterSpacing: "-1px",
    },

    signDescription: {
      color: "#64748b",
      fontSize: "14px",
      marginTop: "9px",
      marginBottom: "26px",
      lineHeight: "1.6",
    },

    alert: {
      padding: "12px 14px",
      borderRadius: "12px",
      marginBottom: "18px",
      fontSize: "13px",
      lineHeight: "1.5",
    },

    errorAlert: {
      background: "#fef2f2",
      color: "#b91c1c",
      border:
        "1px solid #fecaca",
    },

    successAlert: {
      background: "#f0fdf4",
      color: "#15803d",
      border:
        "1px solid #bbf7d0",
    },

    label: {
      display: "block",
      color: "#334155",
      fontSize: "13px",
      fontWeight: "700",
      marginBottom: "8px",
    },

    inputWrapper: {
      position: "relative",
      marginBottom: "6px",
    },

    input: {
      width: "100%",
      height: "52px",
      boxSizing: "border-box",
      padding: "0 16px",
      borderRadius: "13px",
      border: "1px solid #e2e8f0",
      outline: "none",
      fontSize: "14px",
      color: "#0f172a",
      background: "#fff",
      transition: "all 0.2s ease",
    },

    passwordInput: {
      paddingRight: "52px",
    },

    eyeButton: {
      position: "absolute",
      right: "8px",
      top: "6px",
      width: "40px",
      height: "40px",
      border: "none",
      borderRadius: "10px",
      background: "#f8fafc",
      cursor: "pointer",
      fontSize: "17px",
    },

    fieldError: {
      color: "#dc2626",
      fontSize: "11px",
      marginBottom: "13px",
      marginTop: "4px",
    },

    rememberRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "10px",
      marginTop: "15px",
      marginBottom: "22px",
    },

    rememberLabel: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      color: "#64748b",
      fontSize: "12px",
      cursor: "pointer",
    },

    checkbox: {
      width: "16px",
      height: "16px",
      accentColor: "#6366f1",
      cursor: "pointer",
    },

    forgotButton: {
      border: "none",
      background: "transparent",
      color: "#6366f1",
      fontSize: "12px",
      fontWeight: "700",
      cursor: "pointer",
      padding: 0,
    },

    submitButton: {
      width: "100%",
      height: "54px",
      border: "none",
      borderRadius: "14px",
      color: "#fff",
      fontSize: "14px",
      fontWeight: "800",
      cursor: loading
        ? "not-allowed"
        : "pointer",
      background:
        "linear-gradient(135deg, #4f46e5, #7c3aed)",
      boxShadow:
        "0 12px 25px rgba(79,70,229,0.25)",
      opacity: loading ? 0.75 : 1,
      transition: "all 0.2s ease",
    },

    registerText: {
      textAlign: "center",
      color: "#64748b",
      fontSize: "13px",
      marginTop: "22px",
    },

    register: {
      color: "#4f46e5",
      fontWeight: "800",
      textDecoration: "none",
      marginLeft: "5px",
    },

    secure: {
      textAlign: "center",
      color: "#94a3b8",
      fontSize: "11px",
      marginTop: "18px",
    },

    modalOverlay: {
      position: "fixed",
      inset: 0,
      background:
        "rgba(2,6,23,0.72)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      zIndex: 1000,
      backdropFilter: "blur(8px)",
    },

    modal: {
      width: "100%",
      maxWidth: "420px",
      background: "#fff",
      borderRadius: "24px",
      padding: "32px",
      boxShadow:
        "0 30px 80px rgba(0,0,0,0.3)",
      textAlign: "center",
    },

    modalIcon: {
      width: "65px",
      height: "65px",
      margin: "0 auto 18px",
      borderRadius: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "28px",
      background: "#eef2ff",
    },

    modalTitle: {
      margin: 0,
      color: "#0f172a",
      fontSize: "23px",
      fontWeight: "800",
    },

    modalText: {
      color: "#64748b",
      fontSize: "13px",
      lineHeight: "1.7",
      marginTop: "12px",
    },

    closeButton: {
      width: "100%",
      height: "48px",
      marginTop: "20px",
      border: "none",
      borderRadius: "12px",
      background: "#4f46e5",
      color: "#fff",
      fontWeight: "700",
      cursor: "pointer",
    },
  };

  return (
    <>
      {/* =================================================
          RESPONSIVE CSS
      ================================================= */}
      <style>
        {`
          * {
            box-sizing: border-box;
          }

          .login-input:focus {
            border-color: #6366f1 !important;
            box-shadow: 0 0 0 4px rgba(99,102,241,0.10);
          }

          .login-submit:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 15px 30px rgba(79,70,229,0.32) !important;
          }

          .login-forgot:hover {
            color: #4338ca !important;
          }

          .login-register:hover {
            text-decoration: underline !important;
          }

          @media (max-width: 950px) {
            .login-wrapper {
              grid-template-columns: 1fr 1fr !important;
            }

            .login-left {
              padding: 40px 30px !important;
            }

            .login-right {
              padding: 40px 30px !important;
            }

            .login-title {
              font-size: 39px !important;
            }
          }

          @media (max-width: 760px) {
            .login-section {
              padding: 15px !important;
            }

            .login-wrapper {
              display: block !important;
              max-width: 520px !important;
              min-height: auto !important;
            }

            .login-left {
              display: none !important;
            }

            .login-right {
              padding: 38px 28px !important;
              border-radius: 30px !important;
            }
          }

          @media (max-width: 500px) {
            .login-section {
              padding: 10px !important;
            }

            .login-right {
              padding: 30px 20px !important;
            }

            .login-sign-title {
              font-size: 29px !important;
            }

            .login-input {
              height: 50px !important;
            }

            .login-submit {
              height: 51px !important;
            }

            .login-wrapper {
              border-radius: 22px !important;
            }
          }

          @media (max-width: 380px) {
            .login-right {
              padding: 25px 16px !important;
            }

            .login-remember-row {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
          }
        `}
      </style>

      {/* =================================================
          MAIN SECTION
      ================================================= */}
      <section
        className="login-section"
        style={styles.section}
      >
        <div style={styles.orb1}></div>
        <div style={styles.orb2}></div>

        <div
          className="login-wrapper"
          style={styles.wrapper}
        >
          {/* =================================================
              LEFT SIDE
          ================================================= */}
          <div
            className="login-left"
            style={{
              ...styles.left,
              position: "relative",
            }}
          >
            {/* Parent Brand */}
            <div
              style={{
                ...styles.brand,
                display: "inline-flex",
                alignItems: "center",
                gap: "12px",
                padding: "10px 18px",
                borderRadius: "14px",
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.25)",
                boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
                marginBottom: "22px",
              }}
            >
              <div
                style={{
                  ...styles.brandIcon,
                  width: "46px",
                  height: "46px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                  boxShadow: "0 6px 18px rgba(124,58,237,0.35)",
                  fontSize: "24px",
                }}
              >
                👨‍👩‍👧
              </div>

              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "800",
                  letterSpacing: "0.5px",
                  color: "#ffffff",
                  textShadow: "0 2px 8px rgba(0,0,0,0.18)",
                }}
              >
                Parent
              </span>
            </div>

            <div
              style={{
                ...styles.badge,
                display: "inline-block",
                padding: "7px 14px",
                borderRadius: "30px",
                background: "rgba(124,58,237,0.15)",
                border: "1px solid rgba(168,85,247,0.35)",
                color: "#e9d5ff",
                fontWeight: "700",
                fontSize: "12px",
                letterSpacing: "1px",
              }}
            >
              SMART LEARNING PLATFORM
            </div>

            <h1
              className="login-title"
              style={{
                ...styles.title,
                marginTop: "22px",
              }}
            >
              Learn Today.
              <br />
              <span
                style={{
                  background: "linear-gradient(90deg, #c084fc, #f0abfc)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Lead Tomorrow.
              </span>
            </h1>

            <p style={styles.description}>
              Access your Parent dashboard,
              academic information, school
              services and digital learning
              resources from one secure platform.
            </p>

            <div style={styles.features}>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>📚</div>
                <strong>Academic Records</strong>
                <br />
                Manage your academic information.
              </div>

              <div style={styles.feature}>
                <div style={styles.featureIcon}>🏫</div>
                <strong>School Services</strong>
                <br />
                Access important school services.
              </div>

              <div style={styles.feature}>
                <div style={styles.featureIcon}>📊</div>
                <strong>Parent Reports</strong>
                <br />
                View your progress and reports.
              </div>

              <div style={styles.feature}>
                <div style={styles.featureIcon}>🔐</div>
                <strong>Secure Access</strong>
                <br />
                Your account is protected.
              </div>
            </div>

            <div style={styles.stats}>
              <div>
                <div style={styles.statNumber}>10K+</div>
                <div style={styles.statLabel}>Schools</div>
              </div>

              <div>
                <div style={styles.statNumber}>5L+</div>
                <div style={styles.statLabel}>Students</div>
              </div>

              <div>
                <div style={styles.statNumber}>24×7</div>
                <div style={styles.statLabel}>Platform</div>
              </div>
            </div>
          </div>

          {/* =================================================
              RIGHT SIDE
          ================================================= */}
          <div
            className="login-right"
            style={styles.right}
          >
            <div style={styles.welcome}>
              WELCOME BACK
            </div>

            <h2
              className="login-sign-title"
              style={styles.signTitle}
            >
              Sign in
            </h2>

            <p style={styles.signDescription}>
              Enter your registered email and
              password to continue.
            </p>

            {/* =================================================
                ERROR
            ================================================= */}
            {error && (
              <div
                style={{
                  ...styles.alert,
                  ...styles.errorAlert,
                }}
              >
                ⚠️ {error}
              </div>
            )}

            {/* =================================================
                SUCCESS
            ================================================= */}
            {successMsg && (
              <div
                style={{
                  ...styles.alert,
                  ...styles.successAlert,
                }}
              >
                ✓ {successMsg}
              </div>
            )}

            {/* =================================================
                FORM
            ================================================= */}
            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div>
                <label style={styles.label}>
                  Email Address
                </label>

                <div style={styles.inputWrapper}>
                  <input
                    className="login-input"
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Enter your email"
                    autoComplete="email"
                    disabled={loading}
                    style={styles.input}
                  />
                </div>

                {fieldErrors.email && (
                  <div style={styles.fieldError}>
                    {fieldErrors.email}
                  </div>
                )}
              </div>

              {/* PASSWORD */}
              <div style={{ marginTop: "10px" }}>
                <label style={styles.label}>
                  Password
                </label>

                <div style={styles.inputWrapper}>
                  <input
                    className="login-input"
                    type={
                      showPassword
                        ? "text"
                        : "password"
                    }
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    disabled={loading}
                    style={{
                      ...styles.input,
                      ...styles.passwordInput,
                    }}
                  />

                  <button
                    type="button"
                    onClick={() =>
                      setShowPassword(
                        (prev) => !prev
                      )
                    }
                    disabled={loading}
                    style={styles.eyeButton}
                    aria-label={
                      showPassword
                        ? "Hide password"
                        : "Show password"
                    }
                  >
                    {showPassword
                      ? "🙈"
                      : "👁️"}
                  </button>
                </div>

                {fieldErrors.password && (
                  <div style={styles.fieldError}>
                    {fieldErrors.password}
                  </div>
                )}
              </div>

              {/* REMEMBER + FORGOT */}
              <div
                className="login-remember-row"
                style={styles.rememberRow}
              >
                <label style={styles.rememberLabel}>
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) =>
                      setRememberMe(
                        e.target.checked
                      )
                    }
                    disabled={loading}
                    style={styles.checkbox}
                  />

                  Remember me
                </label>

                <button
                  type="button"
                  className="login-forgot"
                  onClick={() =>
                    setShowForgotModal(true)
                  }
                  style={styles.forgotButton}
                >
                  Forgot Password?
                </button>
              </div>

              {/* LOGIN BUTTON */}
              <button
                type="submit"
                className="login-submit"
                disabled={loading}
                style={styles.submitButton}
              >
                {loading ? (
                  <>
                    <span
                      style={{
                        display:
                          "inline-block",
                        width: "15px",
                        height: "15px",
                        border:
                          "2px solid rgba(255,255,255,0.4)",
                        borderTopColor:
                          "#fff",
                        borderRadius: "50%",
                        marginRight: "8px",
                        verticalAlign:
                          "middle",
                        animation:
                          "loginSpin 0.7s linear infinite",
                      }}
                    ></span>

                    Signing in...
                  </>
                ) : (
                  <>
                    Sign In
                    <span
                      style={{
                        marginLeft: "8px",
                      }}
                    >
                      →
                    </span>
                  </>
                )}
              </button>
            </form>

            {/* REGISTER */}
            <p style={styles.registerText}>
              Don't have an account?

              <Link
                to="/Register"
                className="login-register"
                style={styles.register}
              >
                Register Now
              </Link>
            </p>

            <div style={styles.secure}>
              🔒 Secure Parent Portal
            </div>
          </div>
        </div>
      </section>

      {/* =================================================
          FORGOT PASSWORD MODAL
      ================================================= */}
      {showForgotModal && (
        <div
          style={styles.modalOverlay}
          onClick={() =>
            setShowForgotModal(false)
          }
        >
          <div
            style={styles.modal}
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div style={styles.modalIcon}>
              🔐
            </div>

            <h3 style={styles.modalTitle}>
              Forgot Password?
            </h3>

            <p style={styles.modalText}>
              Please contact your school
              administrator to reset your
              Parent account password.
            </p>

            <button
              type="button"
              style={styles.closeButton}
              onClick={() =>
                setShowForgotModal(false)
              }
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* =================================================
          SPINNER ANIMATION
      ================================================= */}
      <style>
        {`
          @keyframes loginSpin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </>
  );
}